<template>
  <div class="mt-2">
    <customer-settings
      v-if="loaded"
      :customer="data" />
    <div
      v-if="!loaded"
      class="loading-spinner-wrapper">
      <div class="loading-spinner pb-3 pt-3">
        <span class="loading-spinner-content">
          {{ $t('ui.loadingDataInProgress') }}&hellip;
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import CustomerSettings from '@/views/forms/customer/CustomerSettings.vue';

export default {
  name: 'customer-settings-wrapper',
  components: {
    'customer-settings': CustomerSettings,
  },
  data() {
    return {
      data: {
        id: 0,
        name: '',
        surname: '',
        email: null,
        phone: '',
        city: '',
        post_code: '',
        address: '',
        accepted_terms_and_policy_privacy: false,
        contact_adviser_agreement: false,
        contact_finhub_agreement: false,
      },
      loaded: false,
      removeInProgress: false,
    }
  },
  mounted() {
    this.$bus.$on('customer-settings-reload', this.loadItemData);
    this.loadItemData();
  },
  methods: {
    loadItemData() {
      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/api/customer/customer/item',
        loadedKey: 'loaded',
        outputKey: 'data',
        pagination: false
      });
    },
    submitForm (formData) {
      let formDataToSend = this.prepareFormDataToSend(formData);
      let endpointUrl = '/api/adviser/adviser/update';

      let fileParams = [];
      if (formData.image) {
        fileParams.push('file');
      }

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.$t('ui.savedChanges'),
        successText: this.$t('adviserSettings.yourDataHasBeenSaved'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('adviserSettings.yourDataModifyError'),
        successAction: () => {
          this.loaded = false;
          this.loadItemData();
        }
      }, fileParams);
    },
    prepareFormDataToSend (formData) {
      let formDataToSend = JSON.parse(JSON.stringify(this.data));

      let fieldsToSave = Object.keys(formData);

      for (let i = 0; i < fieldsToSave.length; i++) {
        formDataToSend[fieldsToSave[i]] = formData[fieldsToSave[i]];
      }
      if (!formData.image) {
        delete formDataToSend.image;
      }

      delete formDataToSend.image_url;

      return formDataToSend;
    }
  },
  beforeDestroy () {
    this.$bus.$off('customer-settings-reload', this.loadItemData);
  }
}
</script>
